import { MouseEventHandler, ReactElement } from 'react'
import { NavLink } from 'react-router-dom'
import styled, { css } from 'styled-components'

import { SpinnerIcon } from 'components/Icons/SpinnerIcon'
import { IListItemProps, IStyledItemProps, IItemLinkProps } from './types'

const Container = styled.ul`
  margin: 0px;
  padding: 0px;
`

const Icon = styled.div`
  width: 25px;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    fill: #916ee8;
  }
`

const itemStyle = css<IStyledItemProps>`
  background-color: ${({ isFocused }): string => (isFocused ? '#f4f0ff' : '#ffffff')};
  color: ${({ disabled }): string => (disabled ? '#c1c1d2' : '#28265d')};
  cursor: ${(props): string => (props.disabled ? 'not-allowed' : props.isAction ? 'pointer' : 'text')};
  display: flex;
  align-items: center;
  gap: 0 8px;
  padding: ${({ noPadding }): string => (noPadding ? '0px' : '14px 16px')};
  font-size: 16px;
  line-height: 18.75px;

  &:hover {
    background-color: #f4f0ff;
  }

  ${Icon} svg {
    ${({ disabled }): string => (disabled ? 'fill: #c1c1d2;' : '')}
  }
`
const StyledItem = styled.li`
  ${itemStyle}
`

const Link = styled(NavLink)`
  ${itemStyle}

  text-decoration: none;
  width: 100%;
`

const StyledSpinnerIcon = styled(SpinnerIcon)`
  fill: #5d5c70;
  width: 14px;
  height: 14px;
`

const Item = ({
  children,
  loading,
  isFocused,
  action,
  noPadding,
  disabled,
  ...props
}: IListItemProps): ReactElement => {
  const handleClick: MouseEventHandler<HTMLLIElement> = (e): void => {
    if (disabled) return
    if (props.onClick && !loading) props.onClick(e)
  }

  return (
    <StyledItem
      {...props}
      noPadding={noPadding}
      isAction={action}
      onClick={handleClick}
      isFocused={isFocused}
      disabled={disabled}
    >
      {loading ? <StyledSpinnerIcon /> : children}
    </StyledItem>
  )
}

const ItemLink = ({ children, disabled, href, className }: IItemLinkProps): ReactElement => {
  if (disabled) {
    return (
      <Item disabled className={className}>
        {children}
      </Item>
    )
  } else {
    return (
      <Item noPadding className={className}>
        <Link to={href} isAction>
          {children}
        </Link>
      </Item>
    )
  }
}

export default {
  Container,
  Link,
  Item,
  Icon,
  ItemLink
}
